import { render, staticRenderFns } from "./AddStockTakeShipmentOtherModal.vue?vue&type=template&id=23f008d8&"
import script from "./AddStockTakeShipmentOtherModal.vue?vue&type=script&lang=js&"
export * from "./AddStockTakeShipmentOtherModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports